import { get, post } from '../utils/http';

export const fetchRegisters = () => get('FETCH_REGISTERS', '/law/registers/flat');

export const fetchLawdocuments = (register) =>
	get('FETCH_LAWDOCUMENTS', `/admin/lawdocuments/register/${register}`, 'payload', { register });

export const filter = (query) => ({ type: 'FILTER_LAWDOCUMENTS', payload: query });

export const changeOriginalFilename = (originalFileName) => ({
	type: 'LAWDOCUMENT_CHANGE_ORIGINAL_FILENAME',
	payload: originalFileName,
});

export const showNewLawDocumentDialog = () => ({ type: 'LAWDOCUMENT_SHOW_NEW' });

export const hideNewLawDocumentDialog = () => ({ type: 'LAWDOCUMENT_HIDE_NEW' });

export const createLawDocument = (originalFileName) => {
	let form = new FormData();
	form.append('originalFileName', originalFileName);
	return post('LAWDOCUMENT_CREATE', '/admin/lawdocuments', form);
};



// WEBPACK FOOTER //
// ./src/lawdocument/lawdocumentActions.js